import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { userOption, userResult } from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import orderServices from '../../services/orders/orderservice';
import AddUser from '../admin/AddUser';
import '../../assests/css/common/responsive-ui.css';
import { Calendar } from 'primereact/calendar';

interface SearchPanelProps {
  onSearch: (query: string) => void;
  reloadPage: () => void;
  setLoading: (loading: boolean) => void;
  newUsersList: (value: boolean) => void;
  onDateFilter: (filter: any) => void;
  onDateRangeChange?: (startDate: Date | null, endDate: Date | null) => void;
}

const UsersSearch: React.FC<SearchPanelProps> = ({ onSearch, reloadPage, setLoading, newUsersList, onDateFilter, onDateRangeChange }) => {

  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState<any>();
  const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: '' },];
  const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
  const [orderUser, setOrderUser] = useState<userResult[]>([]);
  const [isAddUserOpen, setAddUser] = useState(false);
  const [keyword, setKeyword] = useState<string>('');
  const [isNewUser, setNewUser] = useState(false);

  // Created date range for main filter + export
  const [createdStartDate, setCreatedStartDate] = useState<Date | null>(null);
  const [createdEndDate, setCreatedEndDate] = useState<Date | null>(null);

  const handleCreatedStartDateChange = (val: Date | null) => {
    setCreatedStartDate(val);
    if (onDateRangeChange) onDateRangeChange(val, createdEndDate);
  };

  const handleCreatedEndDateChange = (val: Date | null) => {
    setCreatedEndDate(val);
    if (onDateRangeChange) onDateRangeChange(createdStartDate, val);
  };

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const [startDate, setStartDate] = useState<any>(yesterday);
  const [endDate, setEndDate] = useState<any>(today);

  useEffect(() => {
    setOrderUser(orderUsers.map((user) => ({
      userID: user.userID,
      detail: `${user.name}, ${user.primaryContactNbr}`,
    })));
  }, [orderUsers]);

  const handleDropdownChange = (e: DropdownChangeEvent) => {
    setSelectedUser(e.value);
  }

  const handleDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response)
        }
      })
    }
  }

  const toISODateStart = (date: Date | null): string | null => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T00:00:00Z`;
  };

  const toISODateEnd = (date: Date | null): string | null => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T23:59:59Z`;
  };

  const handleSearch = () => {
    setLoading(true);
    let searchFilter: string = "?$filter=true";
    if (selectedUser) {
      searchFilter = searchFilter + " and userID eq " + selectedUser;
    }
    if (keyword) {
      searchFilter = searchFilter + " and (startswith(name, '" + keyword + "') or startswith(primaryContactNbr, '" + keyword + "'))";
    }
    if (createdStartDate) {
      searchFilter = searchFilter + " and createdDate ge " + toISODateStart(createdStartDate);
    }
    if (createdEndDate) {
      searchFilter = searchFilter + " and createdDate le " + toISODateEnd(createdEndDate);
    }
    onSearch(searchFilter);
  }

  const resetSearchFields = () => {
    setOrderUsers(blankUserDetail);
    setSelectedUser(null);
    setKeyword('');
    setCreatedStartDate(null);
    setCreatedEndDate(null);
    if (onDateRangeChange) onDateRangeChange(null, null);
    onSearch('');
  }

  const hideAddUserModal = () => {
    setAddUser(!isAddUserOpen);
    reloadPage();
  }

  function handelNewUser() {
    const startDt = startDate.toLocaleDateString('pt-br').split('/').reverse().join('-');
    const endDt = endDate.toLocaleDateString('pt-br').split('/').reverse().join('-');
    setLoading(true);
    var filterdata = {
      FromDate: startDt,
      ToDate: endDt
    }
    onDateFilter(filterdata);
    setNewUser(true);
    newUsersList(true);
  }

  function handleNewUserSearch() {
    const startDt = startDate.toLocaleDateString('pt-br').split('/').reverse().join('-');
    const endDt = endDate.toLocaleDateString('pt-br').split('/').reverse().join('-');
    setLoading(true);
    var filterdata = {
      FromDate: startDt,
      ToDate: endDt
    }
    onDateFilter(filterdata);
    setNewUser(true);
    newUsersList(true);
  }

  function handleNewUserReset() {
    setOrderUsers(blankUserDetail);
    setSelectedUser(null);
    setKeyword('');
    onSearch('');
    setNewUser(false);
    newUsersList(false);
    setStartDate(yesterday);
    setEndDate(today);
  }



  return (
    <>
      <style>{`
          .users-search-container {
              border: 1px solid rgba(76, 175, 80, 0.15);
              background: #ffffff;
              border-radius: 12px;
          }
          .users-search-container .search-panel-header {
              display: flex;
              align-items: center;
              gap: 0.5rem;
              margin-bottom: 1rem;
              padding-bottom: 0.75rem;
              border-bottom: 1px solid #f0f0f0;
          }
          .users-search-container .search-panel-header i {
              color: #4CAF50;
              font-size: 1rem;
          }
          .users-search-container .search-panel-header span {
              font-weight: 600;
              color: #374151;
              font-size: 0.9rem;
          }
          .users-search-container .p-dropdown,
          .users-search-container .p-inputtext,
          .users-search-container .p-calendar {
              height: 40px !important;
              min-height: 40px !important;
              font-size: 0.9rem !important;
              border-radius: 8px !important;
              border-color: #e0e0e0 !important;
              width: 100% !important;
          }
          .users-search-container .p-button {
              height: 40px !important;
              border-radius: 8px !important;
          }
          @media screen and (max-width: 640px) {
              .responsive-btn {
                  width: 100% !important;
                  margin-bottom: 0.25rem;
              }
          }
      `}</style>
      <div className="users-search-container surface-card p-3 shadow-2 mt-3 mb-4" hidden={isNewUser} style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
        <div className="search-panel-header">
          <i className="pi pi-filter-fill"></i>
          <span>Filter Customers</span>
        </div>
        <div className="grid">
          <div className="col-12 sm:col-4 md:col-3">
            <span className="p-input-icon-left w-full">
              <i className="pi pi-search" />
              <InputText type='search' value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder="Keyword Search" />
            </span>
          </div>
          <div className="col-12 sm:col-4 md:col-3">
            <Dropdown
              id="SearchUser"
              name="SearchUser"
              options={orderUser}
              optionLabel="detail"
              optionValue="userID"
              value={selectedUser}
              onChange={handleDropdownChange}
              onFilter={handleDropdownFilter} filter
              placeholder="Search for User/Mobile"
            />
          </div>
          <div className="col-12 sm:col-4 md:col-3">
            <Calendar
              value={createdStartDate}
              onChange={(e) => handleCreatedStartDateChange(e.value as Date | null)}
              dateFormat="dd/mm/yy"
              placeholder="Created From Date"
              showIcon
              showButtonBar
              readOnlyInput
            />
          </div>
          <div className="col-12 sm:col-4 md:col-3">
            <Calendar
              value={createdEndDate}
              onChange={(e) => handleCreatedEndDateChange(e.value as Date | null)}
              dateFormat="dd/mm/yy"
              placeholder="Created To Date"
              showIcon
              showButtonBar
              readOnlyInput
            />
          </div>
          <div className="col-12 flex flex-wrap gap-2 justify-content-end align-items-center mt-1">
            <Button onClick={handleSearch} severity="success" className="responsive-btn" style={{ minWidth: '100px' }}>Filter</Button>
            <Button onClick={resetSearchFields} severity="secondary" outlined className="responsive-btn" style={{ minWidth: '100px' }}>Reset</Button>
            <Button onClick={handelNewUser} severity="info" className="responsive-btn" style={{ background: '#3b82f6', border: 'none', minWidth: '100px' }}>New Users</Button>
            <Button onClick={() => setAddUser(!isAddUserOpen)} severity="help" icon="pi pi-plus" label="Add User" className="responsive-btn" style={{ minWidth: '120px' }} />
          </div>
        </div>
        {isAddUserOpen && <AddUser showAddUserModal={isAddUserOpen} hideAddUserModal={hideAddUserModal} />}
      </div>


      <div className="users-search-container surface-card p-3 shadow-2 mt-3 mb-4" hidden={!isNewUser} style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
        <div className="search-panel-header">
          <i className="pi pi-user-plus"></i>
          <span>Filter New Customers</span>
        </div>
        <div className='grid'>
          <div className="col-12 sm:col-3 md:col-3">
            <Calendar value={startDate} onChange={(e) => setStartDate(e.value)}
              dateFormat="dd/mm/yy" placeholder="Start Date" showIcon />
          </div>
          <div className="col-12 sm:col-3 md:col-3">
            <Calendar value={endDate} onChange={(e) => setEndDate(e.value)}
              dateFormat="dd/mm/yy" placeholder="End Date" showIcon />
          </div>
          <div className="col-12 sm:col-6 md:col-6 flex gap-2 justify-content-start align-items-center">
            <Button onClick={handleNewUserSearch} severity="success" style={{ minWidth: '100px' }}>Filter</Button>
            <Button onClick={handleNewUserReset} severity="secondary" outlined style={{ minWidth: '100px' }}>View All</Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default UsersSearch;
